@let data = section();
@let step = currentStep();

<section class="cms-wizard tg-section">
    <div class="tg-container cms-wizard__grid">
        <div class="cms-wizard__intro">
            @if (data.staticBlockContent) {
                <div class="cms-content" [innerHTML]="data.staticBlockContent | trustHtml"></div>
            }
        </div>

        @if (step) {
            <div class="cms-wizard__panel" aria-live="polite">
                <span class="cms-wizard__counter">{{ stepIndex() + 1 }} / {{ section().wizardItems.length }}</span>

                @if (step.wizardItemTitle) {
                    <h3 class="cms-wizard__title tg-h3">{{ step.wizardItemTitle }}</h3>
                }

                @if (step.wizardItemContent) {
                    <div class="cms-content" [innerHTML]="step.wizardItemContent | trustHtml"></div>
                }

                @if (step.tagsList.length) {
                    <ul class="cms-wizard__list" role="group">
                        @for (tag of step.tagsList; track tag.id) {
                            <li>
                                <button
                                    class="cms-wizard__tag"
                                    type="button"
                                    [class.cms-wizard__tag--selected]="selectedTagIds().has(tag.id)"
                                    [attr.aria-pressed]="selectedTagIds().has(tag.id)"
                                    (click)="toggleTag(tag.id)"
                                >
                                    {{ tag.tagName }}
                                </button>
                            </li>
                        }
                    </ul>

                    <div class="cms-wizard__actions">
                        @if (stepIndex() > 0) {
                            <button class="cms-wizard__prev" type="button" mat-stroked-button (click)="prevStep()">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.1333 15.9995L18.1333 7.99951L20 9.86618L13.8667 15.9995L20 22.1328L18.1333 23.9995L10.1333 15.9995Z" fill="white"/>
                                </svg>
                                {{ 'cms.wizard.prev' | translate }}
                            </button>
                        }

                        <button class="cms-wizard__next" type="button" mat-flat-button [disabled]="!hasSelection()" (click)="nextStep()">
                            {{ 'cms.wizard.next' | translate }}
                        </button>
                    </div>
                } @else if (step.scrollToAnchor) {
                    <div class="cms-wizard__actions">
                        <button
                            class="cms-wizard__cta"
                            type="button"
                            mat-flat-button
                            (click)="scrollToAnchor(step.scrollToAnchor)"
                        >
                            {{ step.scrollToBtnLabel || ('cms.wizard.scrollTo' | translate) }}
                        </button>
                    </div>
                }
            </div>
        }
    </div>
</section>
